import styled from "styled-components";
import { Link } from "react-scroll";

const Container = styled.nav`
  display: flex;
  gap: 30px;
  align-items: center;
`;

const NavLink = styled(Link)`
  color: black;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 20px;

  &.active {
    color: #007bff;
  }

  &:hover {
    color: #007bff;
    background-color: rgba(0, 123, 255, 0.1);
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

const Navigation = () => {
  return (
    <Container>
      <NavLink to="about" smooth={true} duration={500}>About</NavLink>
      <NavLink to="lone" smooth={true} duration={500}>Service</NavLink>
      <NavLink to="contact" smooth={true} duration={500}>Contact</NavLink>
    </Container>
  );
};

export default Navigation;